/** Coordonnées de l'équipe ExpertDevis BTP, publiées sur le site. */
export const SUPPORT = {
  email: 'expertdevisbtp@gmail.com',
  phone: '+235 62 37 99 99',
  whatsappUrl: 'https://wa.me/23562379999',
};

/** Comptes de réception des paiements, affichés sur la page de paiement. */
export const MOBILE_MONEY = [
  { name: 'Airtel Money', number: '+23566774312', display: '+235 66 77 43 12' },
  { name: 'Moov Money', number: '+23599237806', display: '+235 99 23 78 06' },
];

export const OTHER_PAYMENT_CHANNELS = ['Carte prépayée', 'Ria', 'MoneyGram', 'Express Union', 'Western Union'];
